/**
 * Icons for KB suggestions, Actions menu, and coverage UI.
 * Ported from web; keeps icon names in sync with usage (e.g. ['fad', 'heart-pulse']).
 */

import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faUserNurse,
  faHeartPulse,
  faPrescriptionBottleAlt,
  faCapsules,
  faSquarePlus,
  faRotateRight,
  faUtensils,
  faArrowsCross,
  faPrescription,
  faDollarSign,
  faUserDoctor,
  faUserDoctorMessage,
  faKey,
  faCalendarPlus,
  faHouseMedical,
  faUserHeadset,
  faFilesMedical,
  faFlaskVial,
  faClipboard,
  faSyringe,
  faFileSignature,
  faFileInvoice,
  faFileMagnifyingGlass,
  faClipboardQuestion,
  faXRay,
  faFileCheck,
  faCalendarDay,
  faCalendarClock,
  faCalendarCheck,
  faCalendarWeek,
  faCalendarXmark,
  faCalendarStar,
  faHeartCircleCheck,
  faPeopleRoof,
  faScalpelLineDashed,
  faHospitalUser,
  faTruckMedical,
  faHandHoldingMedical,
  faDumbbell,
  faHandsHoldingHeart,
  faCommentMedical,
  faSpa,
  faChartLineUp,
  faHeartCircleBolt,
  faWeightScale,
  faDroplet,
  faLungs,
  faFaceGrimace,
  faBed,
  faPersonWalking,
  faBan,
  faTablets,
  faGlassWater,
  faAppleWhole,
  faBedPulse,
  faWheelchair,
  faScrewdriverWrench,
  faShieldHalved,
  faMoneyBill,
  faFileInvoiceDollar,
  faCoins,
  faChartGantt,
  faFileArrowDown,
  faChartPieSimple,
  faFileUser,
  faCalendarRange,
  faChartColumn,
  faTimeline,
  faPrescriptionBottle,
  faClipboardListCheck,
  faGaugeHigh,
  faBullseyeArrow,
  faReply,
} from '@fortawesome/pro-duotone-svg-icons';

export const loadSuggestionsIcons = () => {
  library.add(
    faUserNurse,
    faHeartPulse,
    faPrescriptionBottleAlt,
    faCapsules,
    faSquarePlus,
    faRotateRight,
    faUtensils,
    faArrowsCross,
    faPrescription,
    faDollarSign,
    faUserDoctor,
    faUserDoctorMessage,
    faKey,
    faCalendarPlus,
    faHouseMedical,
    faUserHeadset,
    faFilesMedical,
    faFlaskVial,
    faClipboard,
    faSyringe,
    faFileSignature,
    faFileInvoice,
    faFileMagnifyingGlass,
    faClipboardQuestion,
    faXRay,
    faFileCheck,
    faCalendarDay,
    faCalendarClock,
    faCalendarCheck,
    faCalendarWeek,
    faCalendarXmark,
    faCalendarStar,
    faHeartCircleCheck,
    faPeopleRoof,
    faScalpelLineDashed,
    faHospitalUser,
    faTruckMedical,
    faHandHoldingMedical,
    faDumbbell,
    faHandsHoldingHeart,
    faCommentMedical,
    faSpa,
    faChartLineUp,
    faHeartCircleBolt,
    faWeightScale,
    faDroplet,
    faLungs,
    faFaceGrimace,
    faBed,
    faPersonWalking,
    faBan,
    faTablets,
    faGlassWater,
    faAppleWhole,
    faBedPulse,
    faWheelchair,
    faScrewdriverWrench,
    faShieldHalved,
    faMoneyBill,
    faFileInvoiceDollar,
    faCoins,
    faChartGantt,
    faFileArrowDown,
    faChartPieSimple,
    faFileUser,
    faCalendarRange,
    faChartColumn,
    faTimeline,
    faPrescriptionBottle,
    faClipboardListCheck,
    faGaugeHigh,
    faBullseyeArrow,
    faReply,
  );
};
